import { Pagination, Skeleton, Timeline } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchBillableAccountHistory, selectLoading, selectPagination } from "../billableAccountsSlice"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { fetchAuditLog, selectAuditLog, selectTotal } from "../../settings/auditLog/auditLogSlice"
import AuditLogDateGroup from "../../settings/auditLog/components/AuditLogDateGroup"
import moment from "moment"

export default function BillableAccountHistory() {
    const dispatch = useDispatch()
    const { clientId, billableAccountId } = useParams()

    const loading = useSelector(selectLoading)
    const pagination = useSelector(selectPagination)
    const auditLog = useSelector(selectAuditLog)
    const total = useSelector(selectTotal)
    const [filter, setFilter] = useState({ billable_account_id: billableAccountId })

    useEffect(() => {
        dispatch(fetchBillableAccountHistory(pagination, filter))
    }, [])

    const handlePaginationChange = (page, pageSize) => {
        dispatch(fetchBillableAccountHistory({ current: page, pageSize: pageSize }, filter))
    }

    const groupedByDate = {}

    auditLog.forEach((version) => {
        // group the objects by day -> L gives you /m/d/y
        // we can actually scope this down to as low as we want, hour, minute, etc...
        const date = moment(version.version.created_at).format("L")

        const target = groupedByDate[date] || []

        target.push(version)

        groupedByDate[date] = target
    })

    return (
        <Skeleton loading={loading}>
            <Timeline style={{ paddingLeft: "7%" }} mode="left">
                {Object.keys(groupedByDate).map((date) => {
                    return <AuditLogDateGroup key={date} date={date} logs={groupedByDate[date]} />
                })}
            </Timeline>

            <Pagination style={{ marginTop: "20px" }} current={pagination.current} pageSize={pagination.pageSize} total={total} onChange={handlePaginationChange} showSizeChanger />
        </Skeleton>
    )
}
